import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { SplashScreenService } from "./splash-screen.service";
import { TokenStorageService } from "src/app/services/token-storage.service";

@Component({
   selector: "app-splash-screen",
   templateUrl: "./splash-screen.component.html",
   styleUrls: ["./splash-screen.component.scss"],
})
export class SplashScreenComponent implements OnInit {
   @ViewChild("splashScreen", { static: true }) splashScreen: ElementRef;
   public isReseller: boolean = this.tokenService.userHasReseller();

   constructor(private el: ElementRef, private splashScreenService: SplashScreenService, private tokenService: TokenStorageService) {}

   ngOnInit(): void {
      this.splashScreenService.init(this.splashScreen);
   }
}
